import { jsx as _jsx } from "react/jsx-runtime";
import { DropdownMenu } from '#pplx/frontend/aether/components/DropdownMenu/index.js';
import { Icon } from '#pplx/frontend/aether/components/Icon/index.js';
import { AskInputPlusMenuFileUpload } from '#pplx/frontend/apps/ask/ask-input/ask-input-plus-menu/components/AskInputPlusMenuFileUpload.js';
import { uploadFilesOrImagesMessage } from '#pplx/frontend/apps/ask/hooks/file-attachments-hooks/fileAttachmentMessages.js';
import { useFilePicker } from '#pplx/frontend/composer-sdk/file-picker/useFilePicker.js';
import { FILE_RETENTION_MESSAGE } from '#pplx/frontend/file-uploads/fileRetentionMessage.js';
import { $icon } from '#pplx/frontend/icons/icon-sprite.js';
import { noop } from 'lodash-es';
import { useCallback } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
/** Composer plus-menu presentation for selecting file attachments. */
export function FileAttachmentMenuItem({ canUploadFile, closeMenu, disabled, gateUploadFile, retentionDays, menuMessage = uploadFilesOrImagesMessage, }) {
    const { $t } = useIntl();
    const { open } = useFilePicker();
    const fileRetentionMessage = retentionDays === undefined ? undefined : $t(FILE_RETENTION_MESSAGE, { days: retentionDays });
    const onOpenFilePicker = useCallback(() => {
        open();
        closeMenu();
    }, [closeMenu, open]);
    // Disabled rows render inert; the shared upload item has no disabled state.
    if (disabled) {
        return (_jsx(DropdownMenu.Item, { disabled: true, onSelect: noop, leadingAccessory: $icon('paperclip'), subtitle: fileRetentionMessage, trailingAccessory: !canUploadFile.canUpload ? (_jsx(Icon, { icon: $icon('lock'), size: "small", color: "light" })) : undefined, children: _jsx(FormattedMessage, { ...menuMessage }) }));
    }
    return (_jsx(AskInputPlusMenuFileUpload, { canUploadFile: canUploadFile, gateUploadFile: gateUploadFile, fileMenuMessage: menuMessage, fileRetentionMessage: fileRetentionMessage, onOpenFilePicker: onOpenFilePicker }));
}
//# sourceMappingURL=FileAttachmentMenuItem.js.map